(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector(
		".swiper--multicolumn"
	);

	const initSlider = () => {
		if (swiperMulticolumn) return;
		multicolumnSwipeEnabled.classList.add("multicolumn-swiper-wrapper");
		const slides = document.querySelectorAll(".multicolumn-list__item");

		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
		const paginationEl = multicolumnSwipeEnabled.querySelector(".multicolumn-pagination");
			if (paginationEl) {
			paginationEl.innerHTML = "";
		}

		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 20,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},

			navigation: {
				nextEl: ".multicolumn-button-next",
				prevEl: ".multicolumn-button-prev",
			},
			pagination: {
  				el: multicolumnSwipeEnabled.querySelector(".multicolumn-pagination"),
  				clickable: true,
			},
			on: {
				slideChange: function () {
					this.pagination.update();
				},
				transitionEnd: function () {
					this.pagination.update();
				}
			},
			breakpoints: {
				576: {
					slidesPerView: 2.4,
				},
			},
		});
	};
	const destroySlider = () => {
		multicolumnSwipeEnabled.classList.remove("multicolumn-swiper-wrapper");
		const slides = document.querySelectorAll(".multicolumn-list__item");

		 if (swiperMulticolumn) {
			swiperMulticolumn.destroy(true, true);
			swiperMulticolumn = null;
		  }
		
		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 990 && multicolumnSwipeEnabled) {
				initSlider();
			} else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	initMulticolumn();
	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
	});
})();
